import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { requestInstallerPaperwork, clearInstallerPaperwork } from 'actionCreators';
import PageActionBar from 'components/PageActionBar';
import ReportFilters from 'ReportFilters';
import MessageBox from 'components/MessageBox';
import Loading from 'components/Loading';
import contentAreaStyles from 'styles/contentArea';
import RTCheckbox from 'styles/checkbox.scss';
import reportStyle from 'styles.scss';
import { Checkbox } from 'react-toolbox';
import { push } from 'react-router-redux';

class InstallerPaperwork extends React.Component {
  constructor(props) {
    super(props);
    const { hide_costs: queriedHideCosts } = props.location.query;
    this.state = { hide_costs: queriedHideCosts !== undefined ? queriedHideCosts : true };
  }

  componentDidMount = () => {
    this.props.clearInstallerPaperwork();
    if (this.props.location.search) this.props.requestInstallerPaperwork(this.props.location.query);
  }

  componentWillReceiveProps = (nextProps) => {
    const { report: { paperwork_url: paperworkUrl }, location: { search, query } } = nextProps;
    if (search !== this.props.location.search) {
      if (search) this.props.requestInstallerPaperwork(query);
      else this.props.clearInstallerPaperwork();
    }
    if (paperworkUrl && paperworkUrl !== this.props.report.paperwork_url) {
      if (this.isOneTimeReport(query)) window.location.href = paperworkUrl;
      else window.open(paperworkUrl);
    }
  }

  componentWillUnmount = () => this.props.clearInstallerPaperwork();

  onHideCostsChange = value => this.setState({ hide_costs: value });

  onSubmit = (queryParams) => {
    const query = Object.assign({}, queryParams, this.state);
    if (!this.state.hide_costs) delete query.hide_costs;
    return this.props.push({ pathname: this.props.location.pathname, query });
  }

  isOneTimeReport = query => query.appointment_id || (query.installer_id && query.phase_id);

  render = () => {
    const { report: { loaded, loading, paperwork_url: paperworkUrl, count },
            location } = this.props;
    const hasPaperwork = count > 0;
    const showFilters = !this.isOneTimeReport(location.query);
    return (<div>
      <PageActionBar
        showAdd={false}
        showFiltersBtn={false}
        title="Installations Paperwork"
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        {showFilters && <div className={contentAreaStyles.contentArea}>
          <ReportFilters location={this.props.location} onSubmit={this.onSubmit}>
            <Checkbox
              checked={this.state.hide_costs}
              label="Hide Costs"
              onChange={this.onHideCostsChange}
              className={reportStyle.checkbox}
              theme={RTCheckbox}
            />
          </ReportFilters>
        </div>}
        {(loaded && hasPaperwork) && <div className={contentAreaStyles.contentArea}>
          <a href={paperworkUrl} target="_blank" rel="noopener noreferrer">View Installer Paperwork</a>
        </div>}
        {(loaded && !hasPaperwork) && <MessageBox
          error
          message="No installations scheduled for the selected options"
        />}
        {loading && <Loading />}
      </div>
    </div>);
  }
}

InstallerPaperwork.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  report: PropTypes.shape({
    loaded: PropTypes.bool,
    paperwork_url: PropTypes.string,
    count: PropTypes.number,
  }),
  requestInstallerPaperwork: PropTypes.func.isRequired,
  clearInstallerPaperwork: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

export default connect(state => ({
  report: state.reports.installerPaperwork,
}), { requestInstallerPaperwork, clearInstallerPaperwork, push })(InstallerPaperwork);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/installerPaperwork/index.jsx